import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import OrderListPage from 'src/components/views/Order/OrderListPage';
import { IOrderInfo } from 'src/entity/OrderEntity';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import { selectOrder } from 'src/redux/actions';
import { fetchDrugStoresIfNeeded } from 'src/redux/actions/drugStoreCreator';
import { setPreOrderSendStatus } from 'src/redux/actions/webSocketCreator';

const mapStateToProps = ({ userState: { isAgent, userInfo }, drugStoreState: { drugStores }, webSocketState: { order_id } }: IStoreState) => ({
  isAgent,
  userInfo,
  drugStores,
  order_id,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    setPreOrderSendStatus: (uuid: string) => dispatch(setPreOrderSendStatus(uuid)),
    fetchDrugStoresIfNeeded: () => dispatch(fetchDrugStoresIfNeeded()),
    selectOrder: (order: IOrderInfo) => dispatch(selectOrder(order)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderListPage);



// WEBPACK FOOTER //
// ./src/containers/OrderList.ts